// extracted by mini-css-extract-plugin
module.exports = {"projectCard":"style-module_projectCard__1z6FtIi3jLDB6MxYdcG4CR"};